import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class SocialService {
  constructor($http, $localStorage, $state, $q, SecurityService, $window, AuthService, EnvService, $rootScope, $timeout) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$window = $window;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.PubNub = null;
    this.unsortedChannelList = [];
    this.nestedChannelList = [];
    this.arrayOfImageUrlsForGallery = [];
    this.controlChannelVal = null;
  }

  initFB() {
    var _this = this;
    let facebook_app_id = _this.$env.EnvironmentConfig.fb_app_id;
    let fb = _this.$window.FB;
    if (fb) {
      fb.init({
        appId: facebook_app_id,
        status: true,
        cookie: true,
        xfbml: true,
        version: "v2.8",
      });
    }
  }

  fbTrackRegistration(data) {
    var _this = this;
    let fb = _this.$window.FB;
    if (fb) {
      console.log("dbging -- tracking registration...");
      fb.AppEvents.logEvent("jbl_registered", null, data);
    }
  }

  fbTrackLogin(data) {
    var _this = this;
    let fb = _this.$window.FB;
    console.log("fbTrackLogin");
    console.dir(data);
    console.dir(fb);
    if (fb) {
      console.log("dbging -- tracking login...");
      fb.AppEvents.logEvent("jbl_logged_in", null, data);
    }
  }
}

SocialService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "$window", "auth", "env", "$rootScope", "$timeout"];



// WEBPACK FOOTER //
// ./client/app/services/social.js